import styled, { css } from 'styled-components';
import Tooltip from '../Tooltip';

interface containerInterface {
  error: boolean;
}

export const Container = styled.div<containerInterface>`
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #0c5c75;
  background: transparent;
  display: flex;
  width: 100%;

  & select {
    flex: 1;
    width: 100%;
    background: transparent;
    border: none;
    color: #0c5c75;
    height: 26px;
    padding: 0;
    option {
      background: white;
      color: #0c5c75;
    }
  }
  ${props =>
    props.error &&
    css`
      border-color: #c53030;
    `}
`;

export const Error = styled(Tooltip)`
  display: flex;
  position: absolute;
  background-color: transparent;
  height: 40px;
  align-items: center;
  margin-left: -40px;
  max-width: 40px;
  padding-left: 10px;

  svg {
    margin: 0;
  }

  span {
    border: none;
    background: #c53030;
    color: #fff;
    margin-left: 160px;

    &::before {
      border-color: none;
    }
  }
`;
